import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Sparkles } from 'lucide-react';
const bonuses = ['Plantilla de análisis de ventas', 'Pack de hooks para anuncios de iPhone', 'Pack de copies para campañas de mensajes', 'Checklist antes de activar campañas', 'Estructura de campañas lista para copiar', 'Ejemplos de anuncios por modelo y por plan canje'];
export function Bonus() {
  return <section className="py-20 bg-white border-t border-zinc-200" data-id="element-40">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-42">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-600 rounded-full mb-6" data-id="element-43">
            <Sparkles className="w-6 h-6" data-id="element-44" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-4" data-id="element-45">
            Además, te llevás recursos listos para usar
          </h2>
          <p className="text-lg text-zinc-600" data-id="element-46">
            Estos recursos están pensados para que no tengas que empezar desde
            cero.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-47">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 p-4 bg-zinc-50 rounded-xl border border-zinc-200" data-id="element-48">
              <FileText className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-49" />
              <span className="text-zinc-800 font-medium text-sm" data-id="element-50">{bonus}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}